import { useState, useEffect } from 'react';

const NAV_LINKS = [
  { href: '#how', label: 'How it works' },
  { href: '#categories', label: 'Categories' },
  { href: '#businesses', label: 'Businesses' },
  { href: '#about', label: 'About' },
  { href: '#contact', label: 'Contact' },
  { href: '#quote', label: 'Get quotes' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [progress, setProgress] = useState(0);
  const [activeSection, setActiveSection] = useState('');

  useEffect(() => {
    function onScroll() {
      const y = window.scrollY;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      setScrolled(y > 20);
      setProgress(Math.min(100, (y / Math.max(max, 1)) * 100));
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const sections = document.querySelectorAll('.section-observe');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const id = entry.target.id || entry.target.dataset.section;
            setActiveSection(id);
          }
        });
      },
      { threshold: 0.45 }
    );
    sections.forEach((s) => observer.observe(s));
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div className="scroll-progress" aria-hidden="true" style={{ width: `${progress}%` }} />
      <header className={`site-header${scrolled ? ' scrolled' : ''}`}>
        <a className="brand" href="#top" aria-label="Quoteramaa home">
          <img src={`${process.env.PUBLIC_URL}/assets/logo/favicon-orange.svg`} alt="" className="brand-mark" />
          <span className="brand-name">Quoteramaa</span>
        </a>
        <nav className="nav" aria-label="Primary navigation">
          {NAV_LINKS.map(({ href, label }) => {
            const id = href.replace('#', '');
            return (
              <a key={id} href={href} className={activeSection === id ? 'active' : ''}>
                {label}
              </a>
            );
          })}
        </nav>
        <a className="header-cta" href="#quote">Start request</a>
      </header>
    </>
  );
}
